import React from 'react';
import { connect } from 'react-redux';
import './Dashboard.scss';

import Account from '../pages/Account';
import CallsView from '../pages/CallsView';
import Insights from '../pages/Insights';
import Forecast from '../pages/Forecast';
import Upload from '../pages/Upload';

import Navbar from '../components/Navbar/Navbar';

import { getAllCalls, getCall, updateCall, deleteCall, updateChatParticipant, getKeyMomentTypes } from '../actions/CallsActions';
import { getAllDeals, addDeal, deleteDeal, updateDeal } from '../actions/DealsActions';
import { logoutUser, mockUser, connectZoomAccount, connectHubspotAccount } from '../actions/UserActions';
import { updateAllCallsUiState } from '../actions/UiActions';

import { isShareLink } from '../helpers/helpers';

const Dashboard = (props) => {
  const { user, ui, calls, deals, tab, mockUser } = props;
  const curTab = tab || 'summary';
  const isShare = isShareLink();
  return (
    <div className='dashboard-outer-container'>
      {!isShare && <Navbar user={user} tab={curTab} mockUser={mockUser} />}
      {curTab === 'upload' && <Upload user={user} />}
      {curTab === 'insights' && <Insights user={user} />}
      {curTab === 'account' && (
        <Account
          logoutUser={props.logoutUser}
          connectZoomAccount={props.connectZoomAccount}
          connectHubspotAccount={props.connectHubspotAccount}
          user={user}
        />
      )}
      {curTab === 'summary' && (
        <CallsView
          ui={ui}
          user={user}
          calls={calls}
          deals={deals}
          getAllDeals={props.getAllDeals}
          getAllCalls={props.getAllCalls}
          getCall={props.getCall}
          deleteCall={props.deleteCall}
          updateCall={props.updateCall}
          updateAllCallsUiState={props.updateAllCallsUiState}
          updateChatParticipant={props.updateChatParticipant}
          getKeyMomentTypes={props.getKeyMomentTypes}
        />
      )}
      {curTab === 'forecast' && (
        <Forecast
          user={user}
          ui={ui}
          deals={deals}
          getAllDeals={props.getAllDeals}
          addDeal={props.addDeal}
          deleteDeal={props.deleteDeal}
          updateDeal={props.updateDeal}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { user, ui, calls, deals } = state;
  return { user, ui, calls, deals };
};

export default connect(mapStateToProps, {
  getAllCalls,
  getAllDeals,
  getCall,
  deleteCall,
  updateCall,
  addDeal,
  deleteDeal,
  updateDeal,
  logoutUser,
  mockUser,
  getKeyMomentTypes,
  connectZoomAccount,
  connectHubspotAccount,
  updateAllCallsUiState,
  updateChatParticipant,
})(Dashboard);
